import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared';
import { PersonaEffects } from './store/personas/persona.effects';
import { EffectsModule } from '@ngrx/effects';
import { PersonaPickerService } from '@app/persona/services/persona-picker.service';
import {
    PersonaListComponent,
    PersonaPickerComponent,
    PersonaPickerModalComponent,
    PersonaPickerPopoverComponent,
    PersonaSelectionPageComponent
} from './containers';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import * as fromPersona from '../persona/store';

@NgModule({
    declarations: [
        PersonaPickerComponent,
        PersonaListComponent,
        PersonaSelectionPageComponent,
        PersonaPickerModalComponent,
        PersonaPickerPopoverComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(fromPersona.personasFeatureKey, fromPersona.reducers),
        EffectsModule.forFeature([
            PersonaEffects
        ]),
        NzRadioModule
    ],
    exports: [
        PersonaPickerComponent,
        PersonaListComponent,
        PersonaSelectionPageComponent
    ],
    providers: [
        PersonaPickerService
    ]
})
export class PersonaModule {
}
